import pageProps from '@/layout/pageProps';
import { getNotice } from '@/utils/api/SSRRequest';

import AnnouncementPage from './index';

export async function getServerSideProps(props) {
  const defaultProps = await pageProps(props);
  const { data } = await getNotice({ lang: props.locale });
  if (props.query.id && !!data) {
    return {
      props: {
        ...defaultProps,
        apiData: data.filter((item) => item.id === props.query.id) || [],
      },
    };
  }
  return { props: { ...defaultProps, apiData: [] || [] } };
}

export default AnnouncementPage;
